import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Users from './pages/Users'
import GeneralOverview from './pages/GeneralOverview'
import FlowPerformance from './pages/FlowPerformance'
import CampaignsDetails from './pages/CampaignsDetails'
import RevenuePerDay from './pages/RevenuePerDay'
import Media from './pages/Media'
import Facebook from './pages/Facebook'
import Google from './pages/Google'
import Microsoft from './pages/Microsoft'
import TikTok from './pages/TikTok'
import SourcePages from './pages/SourcePages'
import ImportData from './pages/ImportData'
import UnassociatedTraffic from './pages/UnassociatedTraffic'
import Alerts from './pages/Alerts'
import Predictions from './pages/Predictions'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* H4 (Fase B #5): /login es la única ruta pública — el resto exige
            sesión iniciada, envuelto en ProtectedRoute + Layout. */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<GeneralOverview />} />
                  <Route path="/general-overview" element={<GeneralOverview />} />
                  <Route path="/flow-performance" element={<FlowPerformance />} />
                  <Route path="/campaigns-details" element={<CampaignsDetails />} />
                  <Route path="/revenue-per-day" element={<RevenuePerDay />} />
                  <Route path="/media-overview" element={<Media />} />
                  <Route path="/facebook-details" element={<Facebook />} />
                  <Route path="/google-details" element={<Google />} />
                  <Route path="/microsoft-details" element={<Microsoft />} />
                  <Route path="/tiktok-details" element={<TikTok />} />
                  <Route path="/source-pages" element={<SourcePages />} />
                  <Route path="/import-data" element={<ImportData />} />
                  <Route path="/unassociated-traffic" element={<UnassociatedTraffic />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/predictions" element={<Predictions />} />
                  <Route
                    path="/users"
                    element={
                      <ProtectedRoute adminOnly>
                        <Users />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
